import { sipQuickDialRelateCdr } from '@/apis/callCenter/callCenter'
import { seaReceive } from '@/apis/highSeaManage'
import { rxkMessageBox } from '@/components/common/RxkMessageBox'
import {
  callCenterStatusEnum,
  callDirection,
  callType,
  dacoMsg,
  dialingScenes
} from '@/enums/callCenter'
import { useCall } from '@/hooks/callCenter/call'
import { useDaco } from '@/hooks/callCenter/daco'
import { useGroupCall } from '@/hooks/callCenter/groupCall'
import { useJsSIP } from '@/hooks/callCenter/jssip'
import { useTurnCall } from '@/hooks/callCenter/turnCall'
import { useResource } from '@/hooks/useResource'
import { useCallCenter } from '@/stores/modules/callCenter'
import type { CallUserInfo, CallUserInfoVO } from '@/types/callCenter/callCenter'
import { customerBtnCode, seaBtnCode } from '@/utils/preObjectManage/utils'
import MyGlobalEvent from '@/utils/bus/baseBus'
import { cloneDeep } from '@/utils/tools'
import { restoreRecycleBin } from '@/apis/recycleBin'
import { useAccountStore } from '@/stores/modules/account'
import { customerBatchDistributeProgress } from '@/apis/customerManage'

export function useCallScreen() {
  const useJsSIPHooks = useJsSIP()
  const callCenter = useCallCenter()
  const useDacoHooks = useDaco()
  const turnCall = useTurnCall()
  const useCallHooks = useCall()
  const useGroupCallHooks = useGroupCall()
  const { userInfo } = useAccountStore()

  const { getMenuInfo } = useResource()
  // 挂断
  function hungUp() {
    if (callCenter.dialingScenes === dialingScenes.groupCall) {
      useJsSIPHooks.jssipHangUp()
      MyGlobalEvent.$emit('cloudGroupCallWorkConsoleRefresh')
    } else {
      if (callCenter.staffDefaultCallType === callType.sip) {
        useJsSIPHooks.jssipHangUp()
      }
      if (callCenter.staffDefaultCallType === callType.daco) {
        callCenter.setShowCallScreen(false)
        useDacoHooks.sendWSPush(JSON.stringify(dacoMsg.ATH))
      }
    }
  }
  function shutDown() {
    turnCall.shutdown()
  }
  function recall() {
    turnCall.reCall()
  }
  function call() {
    callCenter.setShowCallScreen(false)
    callCenter.dialingScenes === dialingScenes.turnCall
      ? turnCall.startRoundCallProcessPc()
      : turnCall.evokeMobileStartRoundCall()
  }
  /**
   * 详情跳转
   */
  function goDetail(customerId: string, realName: string) {
    useCallHooks.jumpToDetail(customerId, realName)
    callCenter.setShowCallScreen(false)
  }
  /**
   * 获取详情地址自定义跳转
   */
  function customDetail(customerId: string, realName: string, jumpCallBack?: Fn) {
    useCallHooks.jumpToDetail(customerId, realName, jumpCallBack)
    callCenter.setShowCallScreen(false)
  }

  /**
   * 领取
   */
  function recive(callUserInfo: CallUserInfoVO, row: Recordable) {
    const isLoading = ElLoading.service({
      lock: true
    })
    console.log('领取成功', callUserInfo, callCenter.dialingScenes)
    getMenuInfo('CRM', 'highSeaManage', false)
      .then(async (res: Recordable) => {
        if (res.resourceList && res.resourceList.length > 0) {
          if (res.resourceList.find((el: any) => el.code === seaBtnCode.RECEIVE)) {
            try {
              const res = await seaReceive({
                trackIds: [row.customerId],
                seaId: row.belongOpenSeaId
              })
              console.log('领取成功', callUserInfo, callCenter.dialingScenes, res)
              isLoading.close()
              if (res && res.errorMessage) {
                ElMessage.error(res.errorMessage)
              } else {
                // 领取成功，打开详情页
                ElMessage.success('领取成功')
                const userInfoVO = cloneDeep(callUserInfo)
                userInfoVO!.title!.unknow = false
                userInfoVO!.title!.dataFrom = 1
                console.log('领取成功', userInfoVO, callCenter.dialingScenes)
                if (callCenter.dialingScenes === dialingScenes.groupCall) {
                  callCenter.setCallCenterStatus(callCenterStatusEnum.CLEANUP)
                  useGroupCallHooks.correlationShopOrderFn({
                    concatId: callUserInfo?.title?.id,
                    linkDataId: callUserInfo?.title?.customerId
                  })
                  useGroupCallHooks.relatepProcessed(callUserInfo?.title?.id || '')
                  callCenter.setGroupCallUserInfo(userInfoVO)
                } else {
                  console.log('领取成功', userInfoVO, callCenter.dialingScenes)
                  callCenter.callDirection === callDirection.out
                    ? callCenter.setCallUserInfo(userInfoVO)
                    : callCenter.setCallUserInfoIn(userInfoVO)
                  if (callCenter.dialingScenes === dialingScenes.turnCall) {
                    await useCallHooks.roundCallRelate(
                      callUserInfo?.title?.customerId || '',
                      userInfoVO.title.roundCustomerId
                    )
                  }
                  if (
                    callCenter.dialingScenes === dialingScenes.quickCall ||
                    callCenter.dialingScenes === dialingScenes.dokaCallIn
                  ) {
                    useCallHooks.quickCallRelate(callUserInfo?.title?.customerId || '')
                  }
                  if (callCenter.dialingScenes === dialingScenes.turnCallApp) {
                    useCallHooks.relateTurnCallApp(
                      callUserInfo?.title?.customerId || '',
                      userInfoVO
                    )
                  }
                }
                useCallHooks.jumpToDetail(
                  callUserInfo?.title?.bizType === '3'
                    ? (callUserInfo?.title?.customerId as string)
                    : (callUserInfo?.title?.objectId as string),
                  callUserInfo?.title?.realName as string
                )
                callCenter.setShowCallScreen(false)
              }
            } catch (error: any) {
              console.log(error, '领取')
              if (error.subCode === 1023) {
                if (callCenter.dialingScenes !== dialingScenes.groupCall) {
                  // 非公海成员
                  rxkMessageBox('领取失败，您非该客户所在公海成员，是否新建客户？', '提示', {
                    confirmButtonText: '新建客户',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }).then(() => {
                    callAddCustom(callUserInfo)
                  })
                }
              }
              isLoading.close()
            }
          } else {
            ElMessage.error('领取失败，暂无权限')
            isLoading.close()
          }
        } else {
          ElMessage.error('领取失败，暂无权限')
          isLoading.close()
        }
      })
      .catch(() => {
        isLoading.close()
      })
  }

  /**
   * 新建
   */
  function callAddCustom(callUserInfo: CallUserInfoVO, type?: string) {
    const isLoading = ElLoading.service({
      lock: true
    })
    getMenuInfo('CRM', 'customerManage', false)
      .then(async res => {
        isLoading.close()
        if (res.resourceList && res.resourceList.length > 0) {
          if (res.resourceList.find((el: any) => el.code === customerBtnCode.CREATE)) {
            if (callCenter.dialingScenes === dialingScenes.groupCall) {
              callCenter.setCallCenterStatus(callCenterStatusEnum.CLEANUP)
              useGroupCallHooks.checkOrderPoolFn(callCenter.groupCallUserInfo?.title?.id || '')
              useGroupCallHooks.relatepProcessed(callCenter.groupCallUserInfo?.title?.id || '')
            } else {
              // 判断被叫号码和联系人名称是否加密，其中一个加密就调用解密接口
              let plaintextPhone: string = callUserInfo.title?.desensitizePhoneNum || '',
                plaintextName: string = callUserInfo.title?.realName || ''
              if (
                useCallHooks.isEncryption({
                  name: plaintextName,
                  phone: plaintextPhone
                }) &&
                (callUserInfo.title?.customerId || callUserInfo.title?.roundCustomerId)
              ) {
                const encryptionInfo: any = await useCallHooks.queryPlaintextInfo({
                  bizCode: type === 'notTurn' ? 90 : 20,
                  dataId:
                    type === 'notTurn' && callUserInfo.title?.bizType === '3'
                      ? callUserInfo.title?.objectId
                      : callUserInfo.title?.roundCustomerId || callUserInfo.title?.customerId
                })
                plaintextPhone = encryptionInfo?.plaintextPhone || plaintextPhone
                plaintextName = encryptionInfo?.plaintextName || plaintextName
              }
              // 设置新建客户姓名和电话
              callCenter.setCallCenterAddCustomData({
                realName: callUserInfo.title?.realName || '',
                originRealName: callUserInfo.title?.realName || '',
                linkPhone: callUserInfo.title?.desensitizePhoneNum || '',
                plaintextPhone,
                plaintextName
              })
              // 快速拨号记录新建状态
              callCenter.setQuickCallAdd(true)
              callCenter.setCallAddCustom(true)
              callCenter.setShowCallScreen(false)
            }
          } else {
            ElMessage.error('请开通新建客户权限')
          }
        } else {
          ElMessage.error('请开通新建客户权限')
        }
      })
      .catch(() => {
        isLoading.close()
      })
  }

  /**
   * 关联
   */
  function associated(row: CallUserInfo, callUserInfo: CallUserInfoVO) {
    rxkMessageBox('通话记录关联客户后不支持修改，请谨慎操作，确认关联该客户吗？', '提示', {
      confirmButtonText: '确定',
      type: 'warning'
    }).then(() => {
      console.log(callUserInfo, '存储关联用户信息')
      callCenter.callDirection === callDirection.out
        ? callCenter.setCallUserInfo(callUserInfo)
        : callCenter.setCallUserInfoIn(callUserInfo)
      if (callCenter.staffDefaultCallType === callType.sip) {
        const uuid = callCenter.jssipCallId
        sipQuickDialRelateCdr({
          gcId: uuid,
          bizType: row.bizType,
          objectId: row.objectId
        })
      } else {
        useDacoHooks.setCallrecordUrl()
      }
      ElMessage.success('关联成功')
      goDetail(
        callUserInfo?.title?.bizType === '3'
          ? (callUserInfo?.title?.customerId as string)
          : (callUserInfo?.title?.objectId as string),
        callUserInfo?.title?.realName as string
      )
    })
  }
  /**
   * 还原
   */
  async function recycleBin(callUserInfo: CallUserInfoVO, row: Recordable) {
    console.log(row, '还原')
    if (row.orderType === 1) {
      ElMessage.error('暂不支持操作！')
      return false
    }
    const isLoading = ElLoading.service({
      lock: true
    })
    try {
      const res = await restoreRecycleBin({
        trackIds: [row.customerId],
        type: 1,
        userIds: [userInfo.id]
      })
      const timer = setInterval(async () => {
        try {
          const progress = await customerBatchDistributeProgress({ key: res })
          if (!progress || progress.isComplete === null) {
            ElMessage.error('还原失败')
            clearInterval(timer)
            isLoading.close()
          }
          if (String(progress.isComplete) === '1') {
            clearInterval(timer)
            isLoading.close()
            const errorMessageList = progress.errorMessageList
            if (errorMessageList && errorMessageList.length) {
              ElMessage.error(errorMessageList[0])
            } else {
              ElMessage.success('还原成功')
              const userInfoVO = cloneDeep(callUserInfo)
              userInfoVO!.title!.unknow = false
              userInfoVO!.title!.dataFrom = 1
              console.log('还原成功', userInfoVO, callCenter.dialingScenes)
              if (callCenter.dialingScenes === dialingScenes.groupCall) {
                callCenter.setCallCenterStatus(callCenterStatusEnum.CLEANUP)
                useGroupCallHooks.correlationShopOrderFn({
                  concatId: callUserInfo?.title?.id,
                  linkDataId: callUserInfo?.title?.customerId
                })
                useGroupCallHooks.relatepProcessed(callUserInfo?.title?.id || '')
                callCenter.setGroupCallUserInfo(userInfoVO)
              } else {
                console.log('还原成功', userInfoVO, callCenter.dialingScenes)
                callCenter.callDirection === callDirection.out
                  ? callCenter.setCallUserInfo(userInfoVO)
                  : callCenter.setCallUserInfoIn(userInfoVO)
                if (callCenter.dialingScenes === dialingScenes.turnCall) {
                  await useCallHooks.roundCallRelate(
                    callUserInfo?.title?.customerId || '',
                    userInfoVO.title.roundCustomerId
                  )
                }
                if (
                  callCenter.dialingScenes === dialingScenes.quickCall ||
                  callCenter.dialingScenes === dialingScenes.dokaCallIn
                ) {
                  useCallHooks.quickCallRelate(callUserInfo?.title?.customerId || '')
                }
                if (callCenter.dialingScenes === dialingScenes.turnCallApp) {
                  useCallHooks.relateTurnCallApp(callUserInfo?.title?.customerId || '', userInfoVO)
                }
              }
              useCallHooks.jumpToDetail(
                callUserInfo?.title?.bizType === '3'
                  ? (callUserInfo?.title?.customerId as string)
                  : (callUserInfo?.title?.objectId as string),
                callUserInfo?.title?.realName as string
              )
              callCenter.setShowCallScreen(false)
            }
          }
        } catch (error) {
          isLoading.close()
        }
      }, 1000)
    } catch (error) {
      isLoading.close()
    }
  }
  return {
    hungUp,
    shutDown,
    recall,
    call,
    recive,
    callAddCustom,
    goDetail,
    associated,
    recycleBin,
    customDetail
  }
}
